module.exports = __webpack_public_path__ + "static/champions_presentation-a24c64ca1688db0b393e4afbc6c441d1.jpg";